.text {
  display: flex;
  justify-content: center;
  color: var(--tuna-content-muted);
}
